"use strict";
function _typeof(e) {
    return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
            }
            : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
}
function ownKeys(e, t) {
    var o = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
            (n = n.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            o.push.apply(o, n);
    }
    return o;
}
function _objectSpread(e) {
    for (var t = 1; t < arguments.length; t++) {
        var o = null != arguments[t] ? arguments[t] : {};
        t % 2
            ? ownKeys(Object(o), !0).forEach(function (t) {
                _defineProperty(e, t, o[t]);
            })
            : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o))
                : ownKeys(Object(o)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
                });
    }
    return e;
}
function _defineProperty(e, t, o) {
    return t in e ? Object.defineProperty(e, t, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = o), e;
}

$(function () {
    // hide the mega menu when clicking outside of it
    window.addEventListener('click', function(e) {
        var container = $('.mega-menu');
        if  (!container.is(e.target) && container.has(e.target).length === 0)
        {
            container.collapse('hide');
        }
    });

    if (document.getElementById('carouselExampleIndicators'))
    {
        // homepage carousel top of page
        const myCarousel = document.getElementById('carouselExampleIndicators');

        myCarousel.addEventListener('slide.bs.carousel', event => {
            $('.carousel-item .slide-prod-image').fadeIn();
            $('.carousel-item.active .slide-prod-image').fadeOut();
        });
    }
});

// disable page scroll when mobile nav is open
$(document).ready(function() {
    if (window.matchMedia("(max-width: 991px)").matches) {
        $('.navbar').on('show.bs.collapse', function() {
            $('body').css('overflow','hidden').css('height','100%');
            $('.header').css('overflow-y','scroll').css('max-height', '100vh');
        });
        $('.navbar').on('hide.bs.collapse', function() {
            $('body').css('overflow','').css('height','');
            $('.header').css('overflow-y','').css('max-height', '');
        });
    }   
});

$(window).on('resize', function() {
    if (window.matchMedia("(max-width: 991px)").matches) {
        $('.navbar').on('show.bs.collapse', function() {
            $('body').css('overflow','hidden').css('height','100%');
            $('.header').css('overflow-y','scroll').css('max-height', '100vh');
        });
        $('.navbar').on('hide.bs.collapse', function() {
            $('body').css('overflow','').css('height','');
            $('.header').css('overflow-y','').css('max-height', '');
        });
    }
}).trigger("resize");

function createSpinner(target) {
    var $target = $(target);    
    var $container = $('<div class="d-flex justify-content-center align-items-center w-100 spinner-container my-1">');
    var $spinner = $('<div class="spinner-border" role="status">');

    $spinner.append($('<span class="visually-hidden">Loading...</span>'));
    $container.append($spinner);

    if($target.next().hasClass('spinner-container')) {
        return $container;
    }

    $target.after($container);

    return $container;
}

function initializeProductFilter(initialCategoryCollectionId) {

    $(function () {
        var $category = $('#Category');
        var $filters = $('#ProductFilters');
        var topLevelCategoryId = 277;

        // Populate top-level categories from DAM API
        $.get('https://damapi.marshbellofram.com/categories/'+ topLevelCategoryId +'/descendant-categories').done(function(categories) {

            // On category change, get search properties and build out available options from product data
            $category.change(function () {
                var shopifyCollectionId = $(this).val();

                $filters.empty();
                var $spinner = createSpinner('#ProductFilters');
                var category = categories.find(function(item) { return item.shopifyCollectionId == shopifyCollectionId });
                if(!category) {
                    $spinner.detach();
                }

                if (category) {
                    $.get('https://damapi.marshbellofram.com/categories/' + category.id + '/product-values').done(function(dropdowns) {
                        $spinner.detach();
                        for (var dropdown of dropdowns) {
                            var property = dropdown.name;
                            var $div = $('<div class="mb-3">');
                            var $label = $('<label class="form-label fw-medium text-body font-size-sm">').text(property.replace(/^(filter +)/i,""));
                            $div.append($label);

                            var $select = $('<select class="form-select border-gray rounded-0">').attr('name', property).attr('id', property);
                            $select.append('<option value="">-- Choose --</option>');

                            for (var value of dropdown.values) {
                                var $option = $('<option>').attr('value', value).text(value);
                                $select.append($option);
                            }

                            $div.append($select);

                            $filters.append($div);
                        }
                    });
                }
            });

            function buildResults(parentCategory, level) {
                let children = categories.filter(t => t.parentCategory && t.parentCategory.id == parentCategory);
                let prefix = repeat('&nbsp;&nbsp;', level);
                prefix = repeat('&emsp;', level);
                if(level > 0) {
                  prefix += '&angrt;';
                }
            
                for(var child of children) {
                    var $option = $('<option>').html(prefix + child.name).val(child.shopifyCollectionId);

                    $category.append($option);
                    if (initialCategoryCollectionId == child.shopifyCollectionId) {
                        $option.attr('selected', true);
                        $category.trigger('change');
                    }

                    buildResults(child.id, level + 1);
                }
            }
            
            function repeat(string, times) {
                var result = '';
                for(var i = 0; i < times; i++) {
                    result += string;
                }
                return result;
            }

            buildResults(topLevelCategoryId, 0);
        });
    });

}

function initializePartNumberFilter(shopifyProductId) {
    $(function () {
        var $partNumberTableHeader = $('.part-number-table table thead tr');
        var $partNumberTableBody = $('.part-number-table table tbody');
        var $filters = $('#VariationFilters');
        var $results = $('#VariationResults');
        var $clearResultsButton = $('#VariationClearResults');

        var $tableSpinner;
        $.get('https://damapi.marshbellofram.com/products?_where%5B0%5D%5BshopifyProductId%5D=' + shopifyProductId).done(function (products) {
            if (products.length == 1) {
                var product = products[0];
                $.get('https://damapi.marshbellofram.com/products/' + product.id + '/summary').done(function(summary) {
                    var showAsTable = false;
                    var tableVal = summary.values['Shopify Table View'];
                    showAsTable = tableVal && (tableVal.value == true || tableVal.value == 'true');
    
                    if(showAsTable || window.location.search.includes('table')) {
                        $tableSpinner = createSpinner('.part-number-table table');
                        $('.part-number-table').removeClass('d-none');
                    } else {
                        $('.find-part-number').removeClass('d-none');
                    }
    
                    // hide the clear results button
                    $clearResultsButton.hide();
    
                    $('#VariationSearch').submit(function (e) {
                        e.preventDefault();
    
                        $results.empty();
    
                        var params = $('#VariationFilters select').toArray().map(function (select) {
                            return {
                                name: $(select).attr('name'),
                                value: $(select).val()
                            };
                        })
                            .filter(function (param) { return param.value; })
                            .reduce(function (acc, curr) {
                                acc[curr.name] = curr.value;
                                return acc;
                            }, {});
    
                        if (Object.keys(params).length == 0) {
                            alert('You must choose at least one filter to find your part number.');
                            return;
                        }
    
                        var $variationSearchSpinner = createSpinner('#VariationResults');
                        $.get('https://damapi.marshbellofram.com/products/' + product.id + '/variation-search', params).done(function (results) {
                            $variationSearchSpinner.detach();
                            for (var result of results) {
                                var $div = $('<div class="bg-white part d-flex justify-content-between align-items-center">').attr('data-variation-id', result.id);
                                var $label = $('<label class="mb-0">');
                                var $name = $('<span>').text(result.name);
                                var $checkbox = $('<input class="me-1 part-number" type="checkbox">').attr('value', result.id);
    
                                if(results.length == 1) {
                                    $checkbox.prop('checked', true);
                                }
    
                                $label.append($checkbox);
                                $label.append($name);
    
                                $div.append($label);
    
                                var description = result.values['Part Number Description'];
                                if(description) {
                                    var $tooltip = $('<i class="bi bi-info-circle-fill">').attr('title', description.value).tooltip();
                                    $div.append($tooltip);
                                }
    
                                $results.append($div);
                            }
    
                            if(results.length == 0) {
                                var $div = $('<div>').html('<strong>This part number requires engineering support, please <a href="/pages/request-a-quote">contact us</a>.</strong>');
                                $results.append($div);
                            }
    
                            // show the clear results button
                            $clearResultsButton.show();
                        });
                    });
    
                    var $valuesSpinner = createSpinner('#VariationFilters');
                    $.get('https://damapi.marshbellofram.com/products/' + product.id + '/variation-values').done(function (values) {                    
                        $valuesSpinner.detach();
                        for (var property of values) {
                            var $col = $('<div class="col-6">');
                            var $div = $('<div class="mb-3">');
                            var $label = $('<label>').text(property.name).attr('for', property.name);
                            $div.append($label);
    
                            var $select = $('<select class="form-select border-gray rounded-0">').attr('name', property.name).attr('id', property.name);
                            $select.append('<option value="">-- Choose --</option>');
    
                            for (var value of property.values) {
                                var $option = $('<option>').attr('value', value).text(value)
                                $select.append($option);
                            }

                            $div.append($select);
                            $col.append($div);
                            $filters.append($col);
                        }
    
                        if(showAsTable || window.location.search.includes('table')) {
                            $.get('https://damapi.marshbellofram.com/products/' + product.id +  '/variation-search').done(function(variations) {
                                if($tableSpinner) {
                                    $tableSpinner.detach();
                                }
                                for(var variation of variations) {
                                    var $tr = $('<tr>');
                                    
                                    var $checkboxTd = $('<td class="text-center">');
                                    var $checkbox = $('<input class="part-number-table" type="checkbox">').attr('value', variation.id);
                                    $checkboxTd.append($checkbox);
    
                                    if(variations.length == 1) {
                                        $checkbox.prop('checked', true);
                                    }
                                    
                                    var $nameTd = $('<td>').text(variation.name);
    
                                    var $descriptionTd = $('<td>').text('N/A');
    
                                    var description = variation.values['Part Number Description'];
                                    if(description) {
                                        $descriptionTd.text(description.value);
                                    }
    
                                    $tr.append($checkboxTd);
                                    $tr.append($nameTd);
                                    $tr.append($descriptionTd);
    
                                    $partNumberTableBody.append($tr);
                                }
                            });
                        }
                    });
                });
            }
        });

        $('#VariationClearResults').click( function(e) {
            e.preventDefault();

            // clear the search results
            $results.empty();

            // reset the form
            $('#VariationSearch')[0].reset();

            // hide the clear results button
            $clearResultsButton.hide();

            // prevent page refresh on form reset
            return false;
        });

        $('#SaveToWishListTable').click(function(e) {
            e.preventDefault();

            var variations = $('.part-number-table').toArray().map(function(item) { 
                var $item = $(item);
                if(!$item.is(':checked')) {
                    return null;
                }

                return {
                    variationId: parseInt($item.val()),
                    partNumber: $item.text()
                };
            }).filter(function(variation) { return !!variation; });

            if(variations.length > 0) {
                for(var variation of variations) {
                    addToWishList(shopifyProductId, variation.variationId, variation.partNumber);
                }

                $('#savedItemsModal').modal('show');
            } else {
                alert('You need at least one part number to save to your list.');
            }
        });

        $('#SaveToWishList').click(function(e) {
            e.preventDefault();

            var variations = $('.part-number').toArray().map(function(item) { 
                var $item = $(item);
                if(!$item.is(':checked')) {
                    return null;
                }

                return {
                    variationId: parseInt($item.val()),
                    partNumber: $item.text()
                };
            }).filter(function(variation) { return !!variation; });

            if(variations.length > 0) {
                for(var variation of variations) {
                    addToWishList(shopifyProductId, variation.variationId, variation.partNumber);
                }

                $('#savedItemsModal').modal('show');
            } else {
                alert('You need at least one part number to save to your list.');
            }
        });
    });
}
$(function() {
    $('#savedItemsModal').on('show.bs.modal', function(e) {
        displayWishList('#wishListModalItems');
    });
});

/**
 * Displays the wishlist inside the target, pass a selector to the target and optionally an array of the wishlist items.
 */
function displayWishList(target) {
    var wishList = getWishList();

    var $target = $(target);
    $target.empty();

    $('.SavedItemsCount').text(wishList.length + ' item(s) saved')

    $.get('/products.json?limit=1000').done(function(result) {
        wishList.forEach(function(variation) {
            $.get('https://damapi.marshbellofram.com/variations/' + variation.variationId).done(function(damVariation) {
                var product = result.products.find(function(product) { return product.id == variation.shopifyProductId; });
                if(product) {
                    var $div = $('<div class="card mb-3 pt-3 border-0">');
                    var $row = $('<div class="row no-gutters">');
                    
                    var $imageCol = $('<div class="col-md-3 border p-1">');
                    if(product.images.length > 0) {
                        var $link = $('<a>').attr('href', '/products/' + product.handle);
                        var image = product.images[0];
                        var $image = $('<img class="card-img h-100 object-fit-contain">').attr('src', image.src);
    
                        $link.append($image);
                        $imageCol.append($link);
                    }
                    $row.append($imageCol);
    
                    var $detailCol = $('<div class="col-md-7">');
                    var $detailBody = $('<div class="card-body pt-md-0 d-flex flex-column">');
                    var $h5 = $('<a class="h5 text-dk-gray card-title text-capitalize mb-0">').text(product.title).attr('href', '/products/' + product.handle);
                    // var $subtitle = $('<p class="card-text">').text('Relief Valve');
                    var $itemNo = $('<p class="card-text font-weight-700 pb-0 mb-1">').text('Item # ' + damVariation.name);

                    var $description = $('<small class="text-muted mb-3">');
                    if(damVariation.values) {
                        var description = damVariation.values['Part Number Description'];
                        if(description) {
                            $description.text(description.value);
                        }
                    }
                    
                    var $buttonGroup = $('<div class="btn-group btn-group-primary d-md-inline-block" role="group">');
                    var $removeBtn = $('<a href="#" class="btn btn-link pl-md-0">').text('Remove');
                    $removeBtn.click(function(e) {
                        e.preventDefault();
                        removeFromWishList(variation.shopifyProductId, variation.variationId);
                        displayWishList(target);
                    })
    
                    var $infoBtn = $('<a class="btn btn-link">').text('Request More Info').attr('href', '/pages/request-a-quote?ID=' + product.shopifyProductId + '&VariationID=' + variation.variationId + '&Name=' + encodeURIComponent(product.title + ' - #' + variation.partNumber));
                    $buttonGroup.append($removeBtn);
                    $buttonGroup.append($infoBtn);
    
                    $detailBody.append($h5);
                    $detailBody.append($itemNo);
                    $detailBody.append($description);
                    $detailBody.append($buttonGroup);
    
                    $detailCol.append($detailBody);
    
                    $row.append($detailCol);
    
                    $div.append($row);

                    var $input = $('<input type="hidden" name="variations">').val(variation.variationId);
                    $div.append($input);
    
                    $target.append($div);
                }
            });
        });
    });
}

/**
 * Adds a specific product variation to the wish list.
 */
function addToWishList(shopifyProductId, variationId, partNumber) {
    var wishList = getWishList();
    if(!wishList.find(function(t) { return t.shopifyProductId == shopifyProductId && t.variationId == variationId })) {
        wishList.push({
            shopifyProductId: shopifyProductId,
            variationId: variationId,
            partNumber: partNumber
        });

        saveWishList(wishList);
    }
}

/**
 * Adds a specific product variation to the wish list.
 */
function removeFromWishList(shopifyProductId, variationId) {
    var wishList = getWishList();
    var existing = wishList.find(function(t) { return t.shopifyProductId == shopifyProductId && t.variationId == variationId });
    if(existing) {
        wishList.splice(wishList.indexOf(existing), 1);
    }

    saveWishList(wishList);
}

/**
 * Returns an array of wish list items, object contains shopifyProductId, variationId and partNumber properties.
 */
function getWishList() {
    return JSON.parse(localStorage.getItem('wishList') || '[]');
}

/**
 * Persists the wish list to localStorage.
 */
function saveWishList(wishList) {
    localStorage.setItem('wishList', JSON.stringify(wishList));
}